import { Component, OnInit } from '@angular/core';
import { Property } from 'app/models/property';
import { ApplicationDataService } from 'services/application.service';

@Component({
  selector: 'app-tour-splash',
  templateUrl: './tour-splash.component.html',
  styleUrls: ['./tour-splash.component.css']
})
export class TourSplashComponent implements OnInit {
  modelProperty: Property = null;
  splashHTML: string;

  constructor(private applicationService: ApplicationDataService) {
    const unitcode = localStorage.getItem('YardiID');
    this.applicationService.getPropertyForShowing(unitcode).subscribe(res => this.onGetProperty(res.results));
  }

  ngOnInit(): void {

  }

  onGetProperty(property: Property[]) {
    localStorage.setItem('SelectedProperty', JSON.stringify(property));
    this.modelProperty = property[0];
  }

}
